import { Box, Button, Typography } from "@mui/material";

const EmptyPage = ({
  title,
  TypographySx,
  image,
  imageStyle,
  boxSx,
  onClick,
  buttonText,
  buttonSx,
}) => {
  return (
    <>
      <Box sx={boxSx}>
        <img src={image} alt="No pages" style={imageStyle} />
        <Typography
          variant="body1"
          textAlign="center"
          sx={{ pt: 3, ...TypographySx }}
        >
          {title}
        </Typography>
        <Button
          sx={{ p: 1, width: "30%", my: 2, ...buttonSx }}
          variant="contained"
          color="error"
          onClick={onClick}
        >
          <Typography color={"white"}>{buttonText}</Typography>
        </Button>
      </Box>
    </>
  );
};

export default EmptyPage;
